import { type DataTypeConfigType } from '@repo/utils';
import { type DataTypeType } from 'advanced-filters/data';

export const getLeadAttributes = `
    query getLeadAttributes {
      leadAttributes {
        value: id
        label: attributeName
        dataType
        schemaName
        dataTypeConfig {
          dropdownRenderType
        }
      }
    }
  `;

export interface GetLeadAttributesType {
  leadAttributes: {
    value: string;
    label: string;
    dataType: DataTypeType;
    schemaName: string;
    dataTypeConfig: Partial<DataTypeConfigType>
  }[];
}
